module.exports = __webpack_public_path__ + "img/f5.66d87b6e.png";